export type ApiConnectorConfig = {
  url: string;
  method?: 'POST' | 'PUT';
  auth?: { 
    type: 'none' | 'bearer' | 'header'; 
    token?: string; 
    headerName?: string; 
    headerValue?: string; 
  };
  extraHeaders?: Record<string, string>;
};

export async function sendToExternalApi(cfg: ApiConnectorConfig, payload: any) {
  const headers: Record<string, string> = { 
    'Content-Type': 'application/json', 
    ...(cfg.extraHeaders || {}) 
  };
  
  if (cfg.auth?.type === 'bearer' && cfg.auth.token) {
    headers['Authorization'] = `Bearer ${cfg.auth.token}`;
  }
  
  if (cfg.auth?.type === 'header' && cfg.auth.headerName && cfg.auth.headerValue) {
    headers[cfg.auth.headerName] = cfg.auth.headerValue;
  }

  const res = await fetch(cfg.url, {
    method: cfg.method || 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`External API ${res.status}: ${text || res.statusText}`);
  }
  
  return res.json().catch(() => ({}));
}

// Test connection function
export async function testApiConnection(cfg: ApiConnectorConfig) {
  const testPayload = { test: true, timestamp: new Date().toISOString() };
  return await sendToExternalApi(cfg, testPayload);
}
